/**
 * Tailwind-based Pagination Component
 * Handles pagination navigation and styling
 */

function initializePagination() {
	const paginationContainer = document.querySelector('.flex.justify-center.items-center');
	if (!paginationContainer) return;

	const paginationLinks = paginationContainer.querySelectorAll('.page-numbers');
    
	paginationLinks.forEach(link => {
		// Add Tailwind classes to existing pagination links
		link.classList.add(
			'inline-flex', 'items-center', 'justify-center',
			'min-w-11', 'h-11', 'px-4', 'py-2',
			'border-2', 'border-norceca-blue/20',
			'rounded-lg', 'text-norceca-blue', 'font-semibold',
			'text-sm', 'bg-white/90', 'backdrop-blur-sm',
			'transition-all', 'duration-300', 'ease-in-out',
			'relative', 'overflow-hidden', 'mx-1',
			'hover:border-norceca-blue', 'hover:bg-norceca-blue/10',
			'hover:text-norceca-blue', 'hover:-translate-y-0.5',
			'hover:shadow-lg', 'hover:shadow-norceca-blue/20',
			'focus:outline-none', 'focus:ring-3', 'focus:ring-norceca-blue/30'
		);

		// Current page styling
		if (link.classList.contains('current')) {
			link.classList.remove('border-norceca-blue/20', 'text-norceca-blue', 'bg-white/90');
			link.classList.add('bg-norceca-blue', 'text-white', 'border-norceca-blue', 'font-bold');
		}

		// Previous/Next button styling
		if (link.classList.contains('prev') || link.classList.contains('next')) {
			link.classList.add('min-w-12', 'font-bold');
            
			// Add arrow icons
			const icon = document.createElement('span');
			icon.classList.add('sr-only');
			if (link.classList.contains('prev')) {
				icon.textContent = 'Previous';
			} else {
				icon.textContent = 'Next';
			}
			link.appendChild(icon);
		}

		// Disabled state
		if (link.classList.contains('disabled') || link.hasAttribute('disabled')) {
			link.classList.add('opacity-50', 'cursor-not-allowed', 'pointer-events-none');
		}

		// Dots styling
		if (link.classList.contains('dots')) {
			link.classList.remove('border-2', 'border-norceca-blue/20', 'bg-white/90');
			link.classList.add('border-0', 'bg-transparent', 'cursor-default');
		}
	});

	// Handle click events
	paginationLinks.forEach(link => {
		link.addEventListener('click', function() {
			// Don't prevent default - let WordPress handle the navigation
			// Just add loading state
			const container = this.closest('.flex.justify-center.items-center');
			if (container) {
				container.classList.add('opacity-60', 'pointer-events-none');
                
				// Remove loading state after a delay
				setTimeout(() => {
					container.classList.remove('opacity-60', 'pointer-events-none');
				}, 1000);
			}
		});
	});
}

function init() {
	initializePagination();
}

export default init;
